import { Mail, CheckCircle2 } from "lucide-react";
import { Reveal } from "../lib/motion";
import { links, btnPrimary } from "../lib/contact";

const POINTS = [
  "Independent-contractor driving opportunities",
  "Flexible ride acceptance",
  "Background screening required",
  "Valid license, registration, and insurance required",
  "Narcan training and readiness required",
  "Commitment to passenger privacy and professional boundaries",
];

export const DriverRecruitment = () => (
  <section id="drivers" className="relative bg-[#FAFAF9] py-20 sm:py-28">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
      <Reveal>
        <div className="relative rounded-[2rem] overflow-hidden bg-[#1F1D2B] p-8 sm:p-12 lg:p-16">
          <div className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#1AD1B9]/15 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#0891B2]/15 blur-3xl" />
          <div className="relative grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#1AD1B9] mb-4">
                Join the Team
              </p>
              <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
                Want to Join the Recovery Rides Driver Team?
              </h2>
              <p className="mt-5 text-base sm:text-lg text-white/75 leading-relaxed">
                We are looking for compassionate, dependable drivers who understand the importance of dignity,
                discretion, safety, and encouragement. Personal or professional experience with substance use
                disorder and recovery is strongly valued.
              </p>
              <a href={links.driverMail} className={`${btnPrimary} mt-8`} data-testid="driver-email">
                <Mail size={18} /> Email About Driving Opportunities
              </a>
            </div>

            <div>
              <div className="mb-5 rounded-2xl overflow-hidden aspect-[16/10] ring-1 ring-white/10 bg-[#1F1D2B]">
                <img
                  src="https://static.prod-images.emergentagent.com/jobs/dc8a482d-361d-4996-9eb5-a4cbac9ec941/images/d461e806c57babf2de383816860e7793eb4192d2afe177ef1815af153352f6b1.jpeg"
                  alt="Illustration of Michael welcoming a new driver to the Recovery Rides team beside a vehicle"
                  className="h-full w-full object-cover"
                />
              </div>
              <ul className="grid gap-3">
                {POINTS.map((p) => (
                  <li
                    key={p}
                    className="flex items-start gap-3 rounded-2xl bg-white/5 border border-white/10 px-5 py-4 text-white/90"
                  >
                    <CheckCircle2 size={20} className="text-[#1AD1B9] shrink-0 mt-0.5" />
                    <span className="text-sm sm:text-base">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
